import axios from "axios";
import {initialCancelFunction} from "../../../../util/Helpers"



export const INSTRUMENTS_URL = "/instruments";

const cancelToken = axios.CancelToken;
let cancelInstrumentDetailsReq = initialCancelFunction;

// READ
export function getInstrumentDetails(instrumentId) {
  cancelInstrumentDetailsReq("Cancel Request");
  return axios.get(`${INSTRUMENTS_URL}/${instrumentId}`, {
      cancelToken: new cancelToken(function executor(cancel) {
        // An executor function receives a cancel function as a parameter
        cancelInstrumentDetailsReq = cancel;
      })
    } 
  );
}


